var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content.introduce)?_c('div',{staticClass:"details-contents"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content.introduce.replace('\n', `<br/><p style='height: 0.2rem;'></p>`))}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }